/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TransactionLinesQueryResult } from '../../models/transaction-lines-query-result';

export interface ApiProductsqueryInternalTransactionlinesSalesArticleIdGet$Plain$Params {
  salesArticleId: string;
}

export function apiProductsqueryInternalTransactionlinesSalesArticleIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiProductsqueryInternalTransactionlinesSalesArticleIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionLinesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProductsqueryInternalTransactionlinesSalesArticleIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('salesArticleId', params.salesArticleId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TransactionLinesQueryResult>;
    })
  );
}

apiProductsqueryInternalTransactionlinesSalesArticleIdGet$Plain.PATH = '/api/productsquery/internal/transactionlines/{salesArticleId}';
